import { render, staticRenderFns } from "./TicketsLogsReportTemplate.vue?vue&type=template&id=1fed1bc8&scoped=true"
import script from "./TicketsLogsReportTemplate.vue?vue&type=script&lang=js"
export * from "./TicketsLogsReportTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fed1bc8",
  null
  
)

export default component.exports